import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
// @mui
import { Stack, InputAdornment, TextField, Button, Checkbox, FormControlLabel, Typography } from '@mui/material';

// ----------------------------------------------------------------------
AccountSettingsForm.propTypes = {
  formik: PropTypes.isRequired,
};

export default function AccountSettingsForm({ formik }) {
  const navigate = useNavigate();

  const { errors, touched, getFieldProps } = formik;

  return (
    <>
      <Stack spacing={3}>
        <TextField
          name="userName"
          label="User Name"
          {...getFieldProps('userName')}
          error={touched.userName && Boolean(errors.userName)}
          helperText={touched.userName && errors.userName}
          // defaultValue="Jaydon Frankie"
          // onChange={(e)=>{setFormData({...formData, [e.target.name]: e.target.value})}}
        />
        <TextField
          name="email"
          label="Email address"
          {...getFieldProps('email')}
          // value="demo@minimals.cc"
          disabled
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                {/* <Button onClick={() => { navigate('/auth/changeemail') }}>
                                    Change
                                </Button> */}
              </InputAdornment>
            ),
          }}
        />

        <TextField
          name="password"
          label="Password"
          type="password"
          value="........"
          disabled
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <Button
                  onClick={() => {
                    navigate('/auth/changepassword');
                  }}
                >
                  Change
                </Button>
              </InputAdornment>
            ),
          }}
        />

        <Typography variant="h5" gutterBottom sx={{ my: 2 }}>
          Email Preferences
        </Typography>

        <FormControlLabel
          control={<Checkbox name="dailyReportEmail" checked disabled {...getFieldProps('dailyReportEmail')} />}
          label="Want daily report email (8:00 AM)?"
        />
        <FormControlLabel
          control={
            <Checkbox
              name="dailyStatusChangeEmail"
              {...getFieldProps('dailyStatusChangeEmail')}
              checked={formik.values.dailyStatusChangeEmail}
            />
          }
          label="Want daily status change email (8:00 PM)?"
        />
      </Stack>
    </>
  );
}
